export default __webpack_public_path__ + "static/media/Allowed.b572ca96.wav";